import { FC, PropsWithChildren } from 'react'
import { useAuth } from 'react-oidc-context'
import { Navigate } from 'react-router-dom'
import { LOGIN_ROUTE } from '../../constants/routing.constants'

export const ProtectedRoute: FC<PropsWithChildren> = ({ children }) => {
    const auth = useAuth()
    const devToken = import.meta.env.DEV ? import.meta.env.VITE_DEV_ACCESS_TOKEN : undefined
    if (devToken) {
        return children
    }
    if (auth.isLoading) {
        return <></>
    }
    if (!auth.isAuthenticated) {
        // user is not authenticated
        return <Navigate to={LOGIN_ROUTE} />
    }
    return children
}
